import { render, staticRenderFns } from "./draftCompany.vue?vue&type=template&id=250cdb8a&scoped=true"
import script from "./draftCompany.vue?vue&type=script&lang=js"
export * from "./draftCompany.vue?vue&type=script&lang=js"
import style0 from "./draftCompany.vue?vue&type=style&index=0&id=250cdb8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250cdb8a",
  null
  
)

export default component.exports